/***
 * paralax Plugin
 * rotates an element when it comes into view
 * 
 ***/	
(function ( $ ) {
 
    $.fn.ptParalaxRotate = function( options ) {

      // This is the easiest way to have default options.
      var settings = $.extend({
          parent: '',
          start: 360,
          rotationMultiplicator: 1,
          percentOfScreen: 30
      }, options );
      
      var paralaxElement = $(this);
      var container;
      
      if(settings.parent == '') {
      	container = paralaxElement;
      } else {
      	container = settings.parent;
      }
		  
		  var stopParalaxing = false;
      
      $(window).on('scroll', function() {
      	
      	var starting = $(window).scrollTop() + $(window).height() - container.offset().top;
      	var paralaxArea = $(window).height() * settings.percentOfScreen/100;
      	
      	if(starting < 0 ) {
    			percent = 0;
    		} else if (starting > paralaxArea)	{
    			percent = 1;
    			stopParalaxing = true;
    		} else {
    			percent = starting/paralaxArea;
    		}
				
		    if(!stopParalaxing) {
		      paralaxElement.css({'transform': 'rotateY(calc('+(1-percent*settings.rotationMultiplicator)+' * '+(settings.start)+'deg))'});

		    } else {
				  paralaxElement.css({'transform': 'rotateY(360deg)'});
		    }
		    
		  });
		  
		  $(window).trigger('scroll');
 
    };
 
}( jQuery ));